export const GET_SEMESTERS = "GET_SEMESTERS"
export const GET_SEMESTERS_FAIL = "GET_SEMESTERS_FAIL"
export const GET_SEMESTERS_SUCCESS = "GET_SEMESTERS_SUCCESS"

export const ADD_NEW_SEMESTER = "ADD_NEW_SEMESTER"
export const ADD_SEMESTER_SUCCESS = "ADD_SEMESTER_SUCCESS"
export const ADD_SEMESTER_FAIL = "ADD_SEMESTER_FAIL"

export const UPDATE_SEMESTER = "UPDATE_SEMESTER"
export const UPDATE_SEMESTER_SUCCESS = "UPDATE_SEMESTER_SUCCESS"
export const UPDATE_SEMESTER_FAIL = "UPDATE_SEMESTER_FAIL"

export const DELETE_SEMESTER = "DELETE_SEMESTER"
export const DELETE_SEMESTER_SUCCESS = "DELETE_SEMESTER_SUCCESS"
export const DELETE_SEMESTER_FAIL = "DELETE_SEMESTER_FAIL"





